module.exports = __webpack_public_path__ + "static/media/caret-red-right.3bd00308.svg";